import { SystemState } from 'src/app/_model/client-state';

export class WorkingTimeRemoteActionType {
  static readonly START_OF_WORK = new WorkingTimeRemoteActionType(
    'startofwork',
    'WORKTIME-REMOTEACTION.SOW.PAGE-TITLE',
    'WORKTIME-REMOTEACTION.SOW.DESCRIPTION',
    'WORKTIME-REMOTEACTION.SOW.TITLE',
    'WORKTIME-REMOTEACTION.SOW.RA.LABEL.SHORT',
    'WORKTIME-REMOTEACTION.SOW.RA.LABEL.LONG'
  );
  static readonly END_OF_WORK = new WorkingTimeRemoteActionType(
    'endofwork',
    'WORKTIME-REMOTEACTION.EOW.PAGE-TITLE',
    'WORKTIME-REMOTEACTION.EOW.DESCRIPTION',
    'WORKTIME-REMOTEACTION.EOW.TITLE',
    'WORKTIME-REMOTEACTION.EOW.RA.LABEL.SHORT',
    'WORKTIME-REMOTEACTION.EOW.RA.LABEL.LONG'
  );
  static readonly START_OF_PAUSE = new WorkingTimeRemoteActionType(
    'startofpause',
    'WORKTIME-REMOTEACTION.SOP.PAGE-TITLE',
    'WORKTIME-REMOTEACTION.SOP.DESCRIPTION',
    'WORKTIME-REMOTEACTION.SOP.TITLE',
    'WORKTIME-REMOTEACTION.SOP.RA.LABEL.SHORT',
    'WORKTIME-REMOTEACTION.SOP.RA.LABEL.LONG'
  );
  static readonly END_OF_PAUSE = new WorkingTimeRemoteActionType(
    'endofpause',
    'WORKTIME-REMOTEACTION.EOP.PAGE-TITLE',
    'WORKTIME-REMOTEACTION.EOP.DESCRIPTION',
    'WORKTIME-REMOTEACTION.EOP.TITLE',
    'WORKTIME-REMOTEACTION.EOP.RA.LABEL.SHORT',
    'WORKTIME-REMOTEACTION.EOP.RA.LABEL.LONG'
  );

  static readonly START_OF_WAIT = new WorkingTimeRemoteActionType(
    'startofwait',
    'WORKTIME-REMOTEACTION.SOWAIT.PAGE-TITLE',
    'WORKTIME-REMOTEACTION.SOWAIT.DESCRIPTION',
    'WORKTIME-REMOTEACTION.SOWAIT.TITLE',
    'WORKTIME-REMOTEACTION.SOWAIT.RA.LABEL.SHORT',
    'WORKTIME-REMOTEACTION.SOWAIT.RA.LABEL.LONG'
  );
  static readonly END_OF_WAIT = new WorkingTimeRemoteActionType(
    'endofwait',
    'WORKTIME-REMOTEACTION.EOWAIT.PAGE-TITLE',
    'WORKTIME-REMOTEACTION.EOWAIT.DESCRIPTION',
    'WORKTIME-REMOTEACTION.EOWAIT.TITLE',
    'WORKTIME-REMOTEACTION.EOWAIT.RA.LABEL.SHORT',
    'WORKTIME-REMOTEACTION.EOWAIT.RA.LABEL.LONG'
  );

  // private to disallow creating other instances of this type
  private constructor(
    public readonly endpoint: string,
    public readonly pageTitle: string,
    public readonly descriptionKey: string,
    public readonly titleKey: string,
    public readonly raShortLabel: string,
    public readonly raLongLabel: string
  ) {}

  toString() {
    return this.endpoint;
  }
}
